export default "__VITE_ASSET__DY_Vj5LP__"